"use client";

import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { OptionsContext } from "@/provider/options-provider";
import { useContext } from "react";
import { FaRegHandPointUp } from "react-icons/fa6";
import { SearchResults } from "../search-results";
import { Button } from "@/components/ui/button";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { useSession } from "next-auth/react";

export default function Explore() {
  const { searchResults, drawerOpen, setDrawerOpen } =
    useContext(OptionsContext);
  const { data: session, status } = useSession();

  if (typeof window === "undefined") return null;

  if (status === "loading") {
    return (
      <div className={"flex items-center justify-center"}>
        <p>Authenticating...</p>
      </div>
    );
  }

  if (status === "authenticated") {
    return (
      <div
        className={cn(
          "flex min-h-screen flex-col bg-slate-200",
          "max-w-full",
          searchResults ? "h-full" : "h-screen",
        )}
      >
        <Separator />
        <div className="px-1.5 md:p-3 xl:p-8">
          <SearchResults />
          <div className="flex h-full flex-col items-center justify-center">
            <div className="mt-10">
              <FaRegHandPointUp
                size={50}
                className="animate-bounce text-slate-500"
              />
            </div>
            <h1 className="text-center text-3xl font-bold text-slate-500">
              Explore research
            </h1>
            <p className="text-center text-lg text-slate-500">
              Search for content, ask questions, and explore. Scroll to the top
              to start a new search.
            </p>
          </div>
        </div>
        <div className="fixed bottom-5 right-10">
          <Button
            className="rounded-full bg-slate-950 shadow-lg hover:bg-indigo-300"
            variant={"outline"}
            disabled={drawerOpen || !searchResults}
            onClick={() => setDrawerOpen(true)}
          >
            <PsychologyIcon
              className={cn("h-5 w-5 text-indigo-300 hover:text-black")}
            />
          </Button>
        </div>
      </div>
    );
  }

  return <p>Access Denied</p>;
}
